export const lotTypes: string[] = ['Prebuy', 'Auto Order'];
